import React from "react";
import { Typography, Card, CardContent } from '@mui/material';
import { format } from "date-fns";
import { Link } from 'react-router-dom';
import "./RankMockCard.css"

function RankMockCard({ rankMock }) {
    var date = new Date(rankMock.creation_date);
    var formattedDate = format(date, "MMM do, yyyy");
    const isMock = rankMock.rank_type === "mock_draft";

    return (
        <Card className="rank-mock-card">
            <CardContent className="rank-mock-card-content">
                <div className="rank-mock-card-description">
                    <div className="rank-mock-header">
                        <Link to={(isMock ? "../mock-draft/" : "../ranking/") + rankMock.data_point_id}>
                            {rankMock.title}
                        </Link>
                    </div>
                    <div className="rank-mock-subheader">
                        <span className={`rank-type-badge ${isMock ? "mock" : "ranking"}`}>
                            {isMock ? "Mock Draft" : "Ranking"}
                        </span>
                        <div className="sub-heading-divider" />
                        <Typography component="p">{formattedDate}</Typography>
                        <div className="sub-heading-divider" />
                        <Link reloadDocument={true} to={"../media-rankings?scouts_id=" + rankMock.scouts_id}>
                            {rankMock.scout_name}
                        </Link>
                        <div className="sub-heading-divider" />
                        <Link reloadDocument={true} to={"../media-rankings?publication_id=" + rankMock.publication_id}>
                            {rankMock.publication_name}
                        </Link>
                        <div className="sub-heading-divider" />
                        <Typography component="p">Draft Year: {rankMock.draft_year}</Typography>
                    </div>
                </div>
            </CardContent>
            <div className="rank-mock-card-divider" />
        </Card>
    );
};

export default RankMockCard;
